import { Component, OnInit, ViewEncapsulation } from '@angular/core';

import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import * as fromRootStore from '@apps/root/store';
import { IAuroraState } from '@apps/aurora.state';

@Component({
    selector: 'aa-view-ch1',
    templateUrl: './view-ch1.component.html',
    styleUrls: [
        './view-ch1.component.scss'
    ],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class ViewCh1Component implements OnInit
{
    public chipsState: Observable<boolean>;

    constructor (
        private store: Store<IAuroraState>
    )
    {
    }

    ngOnInit (): void
    {
        this.chipsState = this.store.select(fromRootStore.getChipsStatus);
    }
}
